import init from './js/SignalSdk';
import events from './js/utils/SignalEvent';
import HUYA from './js/taf/TafProtocol';
import utils from './js/utils/Utils';
import store from './js/utils/store';
import Taf from './js/taf/libwup'
import { version } from '../package.json';

export default {
    HUYA,
    Taf,
    init,
    events,
    utils,
    store,
    version
}